export enum CampaignFundSource {
  companyDivisionBudget = 'companyDivisionBudget',
  brandBudget = 'brandBudget',
}
